import React from "react";

const MdsRow = ({ children, className = "" }) => {
  return (
    <div
      data-component="row"
      className={`grid grid-cols-12 auto-rows-auto gap xxl:gap-x-x2s h-fit ${className}`}
    >
      {children}
    </div>
  );
};

export default MdsRow;
